import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-mpc-dialog',
  templateUrl: './add-mpc-dialog.component.html',
  styleUrls: ['./add-mpc-dialog.component.scss']
})
export class AddMpcDialogComponent {
  user_id: string;
  mount_point = '';
  server = '';
  port = '2101';
  d_user_name = '';
  d_password = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user_id: string },
    private dialogRef: MatDialogRef<AddMpcDialogComponent>,
  ) {
    this.user_id = data.user_id;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  create(): void {
    if (!this.mount_point || !this.server || !this.port || !this.d_user_name || !this.d_password) {
      return;
    }
    const trimmedServer = this.server.trim();
    const trimmedPort = this.port.trim();
    if (!trimmedServer || !this.isPortNumeric(trimmedPort)) {
      return;
    }
    this.dialogRef.close({
      user_id: this.user_id,
      mount_point: this.mount_point,
      server: trimmedServer,
      port: trimmedPort,
      d_user_name: this.d_user_name,
      d_password: this.d_password
    });
  }

  isPortNumeric(value?: string | null): boolean {
    if (!value) return false;
    const trimmed = value.trim();
    if (!trimmed) return false;
    if (!/^\d+$/.test(trimmed)) return false;
    const num = Number(trimmed);
    return num >= 1 && num <= 65535;
  }
}


